import React from "react";
import { Link } from "react-router-dom";
import { LogoName } from "../../Utility/constants";
import "./ExamHead.css"; // Import the CSS file for custom styles
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons"; // Import a profile icon
import UniversalHeader from "./UniversalHeader";

const ExamHeadHeader = () => {
  const isDisabled = true;
  const handleLogout = () => {
    // Clear user data from local storage
    localStorage.removeItem("userEmail");
    localStorage.removeItem("Role");
    localStorage.removeItem("userID");
    // Redirect to the login page or home page
    window.location.href = "/";
  };

  return (
    <>
      <UniversalHeader />
      {/* <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container d-flex justify-content-between">
          <a
            className="navbar-brand"
            href="/examhead-landing"
            style={{ color: "white" }}
          >
            {LogoName}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="manageSchoolDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    Manage Masters
                  </a>
                  <div
                    className="dropdown-menu bg-dark"
                    aria-labelledby="manageSchoolDropdown"
                  >
                    <Link className="dropdown-item" to="/mark-master">
                      Mark Master
                    </Link>
                    <Link className="dropdown-item" to="/grade-master">
                      Grade master
                    </Link>
                    <Link className="dropdown-item" to="/report-card">
                      Report Card
                    </Link>
                    <Link className="dropdown-item" to="/approve-edit-marks-request">
                      Approve Marks Feeding
                    </Link>
                  </div>
                </li>
              </>
            </ul>
          </div>
          <div className="d-flex align-items-center">
            
            <Link to="/profile" className="text-light me-3">
              <FontAwesomeIcon icon={faUserCircle} size="2x" />
            </Link>
            
            <button className="btn btn-outline-light" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </nav> */}
    </>
  );
};

export default ExamHeadHeader;
